import { useState } from "react";
import { useEffect } from "react";
import { Button, Alert } from "react-bootstrap";
import useAuth from "../../../contexts/auth";

import { deleteEditor } from "../../../services/api";
import { getStates } from "../../../services/address";
import LoadingIndicator from "../../../components/LoadingIndicator";
import ConfirmDeleteAccountModal from "../ConfirmDeleteAccountModal";
import UpdateEditorForm from "../../../components/UpdateEditorForm";
import useNotification from "../../../contexts/notification";

export default function AccountEntrepreneur() {
  const [states, setStates] = useState([]);
  const { user, logout } = useAuth();

  const [isLoading, setIsLoading] = useState(true);
  const [showDeleteBtn, setShowDeleteBtn] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const { setMessage } = useNotification();

  useEffect(() => {
    getStates().then((data) => {
      setStates(data);
      setIsLoading(false);
    });
  }, []);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <UpdateEditorForm
        entrepreneurId={user.id}
        states={states}
        onLoaded={() => {
          setShowDeleteBtn(true);
        }}
      />
      {showDeleteBtn && (
        <Alert variant="danger" className="mt-4">
          <Alert.Heading style={{ fontSize: "1.2em", fontWeight: "bold" }}>Você tem certeza?</Alert.Heading>
          <p>Esta ação resultará na exclusão da sua conta na plataforma Caçadores de ofertas, você não poderá mais recuperar seus dados.</p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button
              variant="outline-danger"
              onClick={() => setModalShow(true)}
            >
              Excluir conta
            </Button>
          </div>
        </Alert>
      )}
      <ConfirmDeleteAccountModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        onDelete={async () => {
          await deleteEditor(user);
          setMessage({
            error: true,
            content: "Empreendedor deletado com sucesso",
          })
          logout(true);
        }}
      />
    </>
  );
}
